import { lazy } from 'react';

import { LazyLoad } from '@/shared/ui';

export const ReasonForScanRoute = LazyLoad(
  lazy(() => import('./reason-for-scan').then((module) => ({ default: module.ReasonForScan }))),
);
